/**
 * What part of the day it is, and whether the day is OVER.
 *
 * Pure and import-free so `npm run test:ori` can exercise it (the module these
 * lived in imports `config/brand`, which Node ESM will not resolve).
 */

export type DayPhase = 'morning' | 'midday' | 'evening' | 'night'

export function dayPhase(hour: number): DayPhase {
  if (hour >= 22 || hour < 5) return 'night'
  if (hour >= 17) return 'evening'
  if (hour >= 12) return 'midday'
  return 'morning'
}

/**
 * Is the day genuinely OVER, as opposed to merely dark?
 *
 * `dayPhase` returns 'night' for 22:00–04:59, which is two opposite states
 * wearing one name. At 22:30 the day is spent and "Today's chapter is closed.
 * Rest is part of the plan." is kind and true. At 00:36 the day is half an
 * hour OLD — and the card said the same thing, then offered "Plan tomorrow",
 * which means the day AFTER the one whose plan the app was already holding.
 *
 * Owner caught it on 2026-09-09 at 00:36 PDT: *"it says tomorrow has to be
 * planned, but goes on to suggest after that. Technically, if what 2 have to
 * be worked on is known then why cant that be a part of tomorrow?"* — the
 * selection for that very day existed (`todays_focus` = [175, 172, 173]); only
 * its placement in time did not.
 *
 * So closing the book is for the LATE side of night only. Before dawn the day
 * is ahead of you, and the plan for it is the honest thing to show.
 */
export function isDayClosed(hour: number): boolean {
  return hour >= 22
}

